import React, { useEffect, useState } from "react";
import { Box, Button, Typography } from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import RecentProjects from "./RecentProjects";
import DetailVideo from "./DetailVideo";
import Update from "./Update";
import { fetchProjects } from "../../store/slice/projectHandler";
import { useDispatch, useSelector } from "react-redux";
import { AppDispatch, RootState } from "../../store/store";
//  import Project from "../Project";
// import { useDeviceSize } from "../../hooks";
import { IDLE } from "../../constants";
import VisionStudioProject from "../../components/VisionStudioProjectModal/Index";
import { fetchUserDetails } from "../../store/slice/authSlice";
const Home: React.FC = () => {
  const dispatch: AppDispatch = useDispatch();
  const { projects, status } = useSelector((state: RootState) => state.project);
  React.useEffect(() => {
    if (status === IDLE) {
      dispatch(fetchProjects());
    }
  }, [status, dispatch]);

  const [open, setOpen] = useState(false);

  const handleClose = () => {
    setOpen(false);
    localStorage.setItem("popupOpen", false.toString());
  };

  const handleOpen = (e: any) => {
    setOpen(true);
    localStorage.setItem("popupOpen", true.toString());
  };

  useEffect(() => {
    dispatch(fetchUserDetails())
      .unwrap()
      .then((response) => {
        const parsedStartDate = new Date(response.startDate);
        const today = new Date();

        today.setHours(0, 0, 0, 0);
        if (today < parsedStartDate) {
          window.location.replace("/Login");
        }
      });
    dispatch(fetchProjects());
  }, []);

  return (
    <Box sx={{ background: "#F5F6F9" }}>
      <Box sx={{ margin: "10px" }}>
        <Box
          sx={{
            background: "linear-gradient(90deg, #F3FBFF 0%, #778EDD 100%)",
            padding: "40px 25px",
            minHeight: "max-content",
          }}
        >
          <Typography
            sx={{ color: "#6E7C87", lineHeight: "2", fontSize: "o.8rem" }}
          >
            Welcome User
          </Typography>
          <Typography
            variant="h1"
            sx={{ color: "#252C32", fontSize: "1.4rem", fontWeight: "500" }}
          >
            Unleash Your Data's Potential: Capture & Upload Live from Camera!
          </Typography>
          <Button
            id="newProject"
            variant="contained"
            sx={{
              position: "relative",
              marginTop: "15px",
              transition: "transform 0.3s ease-in-out",
              "&:hover": {
                transform: "scale(1.02)", // Slightly increase size on hover
                boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.2)", // Optional: Add shadow effect
              },
            }}
            endIcon={<AddIcon />}
            onClick={handleOpen}
          >
            Create New Project
          </Button>
        </Box>
        <Box
          sx={{
            display: "flex",
            gap: "10px",
            marginTop: "10px",
            marginRight: "6px",
          }}
        >
          <RecentProjects
            projects={projects}
            error=""
            status=""
            loading={false}
          />
          <DetailVideo />
          <Update />
        </Box>

        <VisionStudioProject
          setOpen={setOpen}
          open={open}
          handleClose={handleClose}
        />
      </Box>
    </Box>
  );
};

export default Home;
